module.exports = __webpack_public_path__ + "img/MGH-Toyosu-2.550b9697.jpg";